import store from '../store';

export default [

    {
        path: '*',
        meta: {
            public: true,
        },
        redirect: {
            path: '/404',
        },
    },
    {
        path: '/404',
        meta: {
            public: true,
        },
        name: 'NotFound',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/errors/NotFound.vue'
        ),
    },
    {
        path: '/403',
        meta: {
            public: true,
        },
        name: 'AccessDenied',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/errors/Deny.vue'
        ),
    },
    {
        path: '/500',
        meta: {
            public: true,
        },
        name: 'ServerError',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/errors/Error.vue'
        ),
    },
    {
        path: '/login',
        meta: {
            public: true,
        },
        name: 'Login',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/login/Login.vue'
        ),
    },
    {
        path: '/',
        meta: {},
        name: 'Root',
        redirect: to => {
            // the function receives the target route as the argument
            // return redirect path/location here.
            if (store.getters['account/currentRole'] == 0) {
                return '/admin/dashboard';
            } else {
                return '/dashboard';
            }
        },
        // redirect: {
        //     name: 'Dashboard'
        // }
    },
    {
        path: '/dashboard',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: 1,
        },
        name: 'Dashboard',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/Dashboard.vue'
        ),
    },
    {
        path: '/search/:search_type/:search_pattern',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Search',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/Search.vue'
        ),
    },
    {
        path: '/admin/dashboard',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'adminDashboard',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/admin/Dashboard.vue'
        ),
    },
    {
        path: '/admin/licence',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Licence',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/admin/Licence.vue'
        ),
    },
    {
        path: '/admin/settings',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Parameters',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/admin/Parameters.vue'
        ),
    },
    {
        path: '/admin/logs',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Logs',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/admin/Logs.vue'
        ),
    },
    {
        path: '/aiRecognition/documents',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AiRecognition',
        component: () => import('@/components/aiRecognition/DocumentListRecognition.vue'),
    },
    {
        path: '/administration/users',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'UserList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/user/UserList.vue'
        ),
    },
    {
        path: '/administration/organization',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Organization',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/organization/Organization.vue'
        ),
    },
    {
        path: '/administration/roles',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'RoleList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/role/RoleList.vue'
        ),
    },
    {
        path: '/administration/roles/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Role',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/role/Role.vue'
        ),
    },
    {
        path: '/administration/delegations',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DelegationList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/delegation/DelegationList.vue'
        ),
    },
    {
        path: '/administration/registered-devices',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'RegisteredDevices',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/registeredDevices/RegisteredDevicesList.vue'
        ),
    },
    {
        path: '/administration/logged-users',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'LoggedUsers',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/user/LoggedUsers.vue'
        ),
    },
    {
        path: '/administration/access-rights',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AccessRightList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/accessRight/AccessRightList.vue'
        ),
    },
    {
        path: '/administration/access-rights/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AccessRightConfig',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/accessRight/AccessRightConfig.vue'
        ),
    },
    {
        path: '/administration/digital-signatures',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DigitalSignatureList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/digitalSignature/DigitalSignatureList.vue'
        ),
    },
    {
        path: '/administration/content-types',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'ContentTypeList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/contentType/ContentTypeList.vue'
        ),
    },
    {
        path: '/administration/content-type/:id?',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'ContentType',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/contentType/ContentType.vue'
        ),
    },
    {
        path: '/administration/content-types/access-rights/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AccessRightsAdministration',
        component: () => import(
            '@/views/administration/contentType/rights/AccessRightsAdministration.vue'
        ),
    },
    {
        path: '/administration/content-types/access-rights-fields/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AccessRightsFields',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/contentType/fieldRights/FieldsRights.vue'
        ),
    },
    {
        path: '/administration/content-types/alerts/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Alerts',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/contentType/alerts/Alerts.vue'
        ),
    },
    {
        path: '/administration/content-types/auto-import-configuration/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AutoImportConfig',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/contentType/autoimport/ContentTypeAutoImportConfig.vue'
        ),
    },
    {
        path: '/administration/content-types/export-config/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'ExportConfig',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/contentType/exportConfig/ExportConfig.vue'
        ),
    },
    {
        path: '/administration/content-type/document-intelligence-settings/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DocumentIntelligenceSettings',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/contentType/documentIntelligence/DocumentIntelligenceListProvidersSettings.vue'
        ),
    },
    {
        path: '/administration/internal-tables',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'InternalTableList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/internalTable/InternalTableList.vue'
        ),
    },
    {
        path: '/administration/flows',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'FlowList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/flow/FlowList.vue'
        ),
    },
    {
        path: '/administration/flows/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Flow',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/flow/Flow.vue'
        ),
    },
    {
        path: '/administration/flows/states/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'States',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/flow/States.vue'
        ),
    },
    {
        path: '/administration/baskets',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'BasketList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/basket/BasketList.vue'
        ),
    },
    {
        path: '/administration/baskets/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Basket',
        component: () => import(
            '@/views/administration/basket/Basket.vue'
        ),
    },
    {
        path: '/administration/reports',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Reports',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/report/Reports.vue'
        ),
    },
    {
        path: '/administration/audits',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AuditList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/audit/AuditList.vue'
        ),
    },
    {
        path: '/administration/plugins',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'PluginList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/plugin/PluginList.vue'
        ),
    },
    {
        path: '/administration/plugins/rights/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'PluginRights',
        component: () => import(
            '@/views/administration/plugin/PluginRights.vue'
        ),
    },
    {
        path: '/administration/deleted-documents',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DeletedDocumentList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/deletedDocument/DeletedDocumentList.vue'
        ),
    },
    {
        path: '/administration/non-indexed-documents',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'NonIndexedDocumentList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/nonIndexedDocument/NonIndexedDocumentList.vue'
        ),
    },
    {
        path: '/administration/locked-documents',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'LockedDocumentList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/lockedDocument/LockedDocumentList.vue'
        ),
    },
    {
        path: '/administration/document-lifecycle',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DocumentLifecycleList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/documentLifecycle/DocumentLifecycleList.vue'
        ),
    },
    {
        path: '/administration/document-lifecycle/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DocumentLifeCycle',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/documentLifecycle/DocumentLifeCycle.vue'
        ),
    },
    {
        path: '/administration/jobs',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'JobList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/dataManagement/JobList.vue'
        ),
    },
    {
        path: '/administration/jobs/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DataManagementJob',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/dataManagement/DataManagementJob.vue'
        ),
    },
    {
        path: '/administration/connected-services',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'ConnectedServicesList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/connectedService/ConnectedServiceList.vue'
        ),
    },
    {
        path: '/administration/registration-activity',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'ActivityRegistry',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/activityRegistry/ActivityRegistry.vue'
        ),
    },
    {
        path: '/administration/logged-users-admin',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'LoggedUsersAdmin',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/admin/LoggedUsersAdmin.vue'
        ),
    },
    {
        path: '/restore-device/:user_id/:device_id',
        meta: {
            public: true,
        },
        name: 'Login',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/login/Login.vue'
        ),
    },
    {
        path: '/organization-login/:organization_id',
        meta: {
            public: true,
        },
        name: 'OrganizationLogin',
        component: () => import(
            '@/views/login/Login.vue'
        ),
    },
    {
        path: '/external/distribution/:distribution_token',
        meta: {
            public: true,
        },
        name: 'ExternalViewer',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/external/ExternalViewer.vue'
        ),
    },
    {
        path: '/external/redirect/:redirect_token',
        meta: {
            public: true,
        },
        name: 'ExternalRedirect',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/external/ExternalRedirect.vue'
        ),
    },
    {
        path: '/administration/content-type/document-intelligence-settings/:contentTypeID/infomaniak-LLM-settings/:settingID',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'InfomaniakLLMSettings',
        component: () => import(
            '@/views/administration/contentType/documentIntelligence/providers/InfomaniakLLMSettings.vue'
        ),
    },
    {
        path: '/administration/content-type/document-intelligence-settings/:contentTypeID/Azure-AI-settings/:settingID',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AzureAISettings',
        component: () => import(
            '@/views/administration/contentType/documentIntelligence/providers/AzureAISettings.vue'
        ),
    },
    {
        path: '/administration/variables',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Variables',
        component: () => import(
            '@/views/administration/variables/VariablesList.vue'
        ),
    },
    {
        path: '/administration/variables/:id',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Variable',
        component: () => import(
            '@/views/administration/variables/Variable.vue'
        ),
    }
];
